import UserActions from "../UserActions";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import PhoneDisplay from "../PhoneDisplay";

const UsersList = ({
  dataList,
  selectedUsers,
  isSelectionMode,
  handleUserSelect,
  setUserViewDetails,
}) => {
  const { checkPermission } = UsePermissionsClaim();
  const checkAllUserActionsPerm =
    checkPermission("add_loan") ||
    checkPermission("add_loan_expense") ||
    checkPermission("add_deduction_expense") ||
    checkPermission("update_user") ||
    checkPermission("payroll_addition") ||
    checkPermission("payroll_deduction") ||
    checkPermission("sup_admin_check") ||
    checkPermission("disable_user");

  return (
    <>
      {dataList.map((data, index) => {
        const isChecked = selectedUsers.includes(data.id);
        return (
          <tr className="table-row" key={index}>
            {isSelectionMode && (
              <td>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleUserSelect(data.id)}
                  className="w-4 h-4 accent-input"
                />
              </td>
            )}
            <td>{data.id}</td>
            <td>
              {data.fullName}
              <br></br>
              <PhoneDisplay
                phone={data.mobileNumber}
                isVerified={data.isPhoneVerified}
              />
            </td>
            <td>{`₹${data.loanBalance}`} </td>
            <td>{`₹${data.pendingBalance}`} </td>
            <td>{`₹${data.totalBalance}`} </td>
            <td>
              <button
                className="tableViewBtn"
                onClick={() => setUserViewDetails(data)}
              >
                View
              </button>
            </td>
            {checkAllUserActionsPerm && (
              <td>
                <UserActions userData={data} />
              </td>
            )}
          </tr>
        );
      })}
    </>
  );
};

export default UsersList;
